import * as React from 'react';
import DocumentTitle from 'react-document-title';
import { useParams } from 'react-router-dom';

import { AgentContent } from '../components/agent/agent-content';
import { AgentLayout } from '../components/agent/agent-layout';
import { AgentPageHeader } from '../components/agent/agent-page-header';
import { ConversationHistorySidebar } from '../components/agent/conversation-history-sidebar';
import { useConversationState } from '../components/agent/use-conversation-state';
import { useAgent } from '../hooks/use-agent';

export const AgentPage: React.FC = () => {
    const { conversationId: urlConversationId } = useParams<{ conversationId?: string }>();
    const { conversationId, onSelectConversation, onNewChat } = useAgent();

    // Load conversation from URL on mount or when URL changes
    React.useEffect(() => {
        // If URL has conversationId and it's different from current, load it
        if (urlConversationId && urlConversationId !== conversationId) {
            onSelectConversation(urlConversationId);
        } else if (!urlConversationId && conversationId) {
            // If URL doesn't have conversationId but we have one in state, start new chat
            onNewChat();
        }
    }, [urlConversationId, conversationId, onSelectConversation, onNewChat]);

    const conversationState = useConversationState({
        variant: 'page'
    });

    const content = <AgentContent state={conversationState} variant="page" />;

    return (
        <DocumentTitle title="Orbit">
            <div id="container">
                <AgentPageHeader />
                <div id="content" className="flex-fill">
                    <AgentLayout sidebar={<ConversationHistorySidebar />} content={content} />
                </div>
            </div>
        </DocumentTitle>
    );
};
